module.exports = __webpack_public_path__ + "assets/images/favicon_white.1c51e5b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/favicon_white.png
// module id = 766
// module chunks = 1